import { useTranslation } from 'react-i18next'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'

import {
  toggleFilterByEmailDialog as openFilterByEmailModal,
  toggleFilterByScreenNameDialog as openFilterByScreenNameModal,
  addFilter,
  toggleFilterByLastSeenDialog as openFilterByLastSeenDialog,
  toggleFilterByJoinDateDialog as openJoinDateFilter,
  toggleFilterByProjectAndEngagementDialog as openProjectAndEngagementLevelFilter,
} from 'redux/slices/FilterBuilder'
import { useAppSelector, useAppDispatch } from 'redux/Hook'
import { FilterItem } from 'types/FilterBuilder'
import { getMenuItem } from 'components/Participants/FilterBuilder/HelperFilterMenu'
import { toggleModal as openSignUpQuestionsModal } from 'redux/slices/SignUpQuestions'
import { AllAdmins } from 'lib/authorization/Roles'

type Props = {
  handleClose: () => void
  filters: FilterItem[]
}

const MODAL_FILTERS = [
  'signUpQuestion',
  'email',
  'screenName',
  'lastSeen',
  'joinDate',
  'projects',
]

const FilterMenus = (props: Props) => {
  const { handleClose, filters } = props
  const { roleName } = useAppSelector((state) => state.user.user)
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const handleModalFiltersClick = (filterName: string) => {
    switch (filterName) {
      case 'signUpQuestion':
        dispatch(openSignUpQuestionsModal())
        break
      case 'email':
        dispatch(openFilterByEmailModal())
        break
      case 'screenName':
        dispatch(openFilterByScreenNameModal())
        break
      case 'lastSeen':
        dispatch(openFilterByLastSeenDialog())
        break
      case 'joinDate':
        dispatch(openJoinDateFilter())
        break
      case 'projects': // this name should match the name of the filter in the FB_FILTER_LIST constants
        dispatch(openProjectAndEngagementLevelFilter())
    }

    handleClose()
  }

  const handleMenuClick = (filter: FilterItem) => {
    if (MODAL_FILTERS.includes(filter.name as string)) {
      handleModalFiltersClick(filter.name as string)

      return
    }

    dispatch(addFilter(filter))

    // This is being passed to close the Filter menu on any menu selection.
    handleClose()
  }

  const isMenuPermitted = (allowedTo: string[]) => {
    if (allowedTo.includes(AllAdmins)) return true

    return allowedTo.includes(roleName)
  }

  const renderOptions = () => {
    return filters.map((item: any, index: number) => {
      const { disabled: isDisabled, allowedTo, tooltipText } = item
      const isPermitted = allowedTo && isMenuPermitted(allowedTo)
      if (!isPermitted) return

      if (tooltipText) {
        return (
          <Tooltip
            placement="right-end"
            title={<>{t?.(tooltipText)}</>}
            arrow
            key={index}
            data-cy={`${item?.name}_filter`}
          >
            <Box>
              {getMenuItem({ item, index, isDisabled, handleMenuClick })}
            </Box>
          </Tooltip>
        )
      }

      return getMenuItem({ item, index, isDisabled, handleMenuClick })
    })
  }

  return <>{renderOptions()}</>
}

export default FilterMenus
